export function removeTags(str) {
  return str.replace(/<[^>]*>/g, '');
}